import { render } from "./StickerDetailPage.vue?vue&type=template&id=4c88831a&ts=true"
import script from "./StickerDetailPage.vue?vue&type=script&lang=ts"
export * from "./StickerDetailPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__